import React from "react";
import Carousel from "react-elastic-carousel";
import StyledTwo from "../components/styledTwo";
import { companyData } from "../rawData/kidsAPI";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "../css/circle.css";

const breakPoint = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 4 },
  { width: 768, itemsToShow: 6 },
  { width: 1024, itemsToShow: 6 },
];

const Brandcarousel = () => {
  return (
    <>
      <div className="container cards-container2">
        <div className="mt-4 mb-4">
          <h4 className="text-center mb-3 mt-3">Browse By Brand</h4>
          <Carousel itemPadding={[3]} breakPoints={breakPoint}>
            {companyData.map((items) => (
              <StyledTwo src={items.image} alt={items.alt} />
            ))}
          </Carousel>
        </div>
      </div>
    </>
  );
};

export default Brandcarousel;
